// Frontend mirror of backend LEVELS_CONFIG titles (level -> title).
// Keep in sync with backend/config/levels.py.
export const LEVEL_TITLES = {
  1: 'Moussaillon',
  2: 'Matelot',
  3: 'Matelot Confirmé',
  4: 'Navigateur',
  5: 'Officier',
  6: 'Capitaine',
  7: 'Commandant',
  8: 'Amiral',
  9: 'Vice-Amiral',
  10: 'Grand Amiral',
  11: 'Légende',
  12: 'Maître des Mers',
  13: 'Commodore',
  14: 'Amiral de la Flotte',
  15: 'Empereur des Océans',
};

export const titleForLevel = (level) => LEVEL_TITLES[level] || 'Moussaillon';
